module.exports = __webpack_public_path__ + "static/media/ol-logo--teal.55c21448.svg";